module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/content-list/content-list.style.scss
// module id = 796
// module chunks = 2